import React from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { Affix, Layout } from 'antd';
import { useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import SideMenu from '../../../components/SideMenu';

import { access, defaultRoute } from '../../../../common/Tool';
import CommonEventsMyevents from '../../CommonEventsMyevents';
// import CommonEventsCalendar from '../../CommonEventsCalendar';
// import CommonEventsFestivali from '../../CommonEventsFestivali';
// import CommonEventsSerii from '../../_CommonEventsSerii';
import CommonEventsAdmin from '../../CommonEventsAdmin';
import CommonEventsByID from '../../CommonEventsByID';
import CommonEventsAdminByID from '../../CommonEventsAdminByID';
import CommonEventsByIDAvatarTemplate from '../../CommonEventsByIDAvatarTemplate';
import CommonEventsByIDAvatar from '../../CommonEventsByIDAvatar';
import { BreadcrumbsProvider, MenuLevelThreeContext, MenuLevelThreeElementContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Events(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const siteAccess = useSelector(state => state.siteAccess.value);

    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status, () => { }); // Статусы
    const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const { menu: m } = props;

    const menu = (status, notify) => {
        const x = [
            // {
            //     uuid: ":id",
            //     hidden: true,
            //     name: "Мероприятие",
            //     component: (props) => (<CommonEventsByID {...props} auth={auth} />),
            //     role: [
            //         { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            //     ]
            // },
            {
                uuid: "my-events",
                name: "Мои мероприятия",
                default: true,
                component: (props) => (<CommonEventsMyevents {...props} auth={auth} />),
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                ]
            },
            {
                uuid: "calendar",
                name: "Мероприятия",
                href: `${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`,
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                ]
            },
             {
                uuid: "festivali",
                name: "Фестивали",
                href: `${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/festivals`,
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                ]
            },
            {
                uuid: "serii",
                name: "Серии",
                href: `${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/series`,
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                ]
            },
            // {
            //     uuid: "admin",
            //     name: "Администрирование",
            //     component: (props) => (<CommonEventsAdmin {...props} auth={auth} />),
            //     role: [
            //         { "ID": 30, "nazvanie": "АдминистраторМероприятия" },
            //     ]
            // },
            // {
            //     uuid: "admin/:id",
            //     hidden: true,
            //     name: "Мероприятие",
            //     component: (props) => (<CommonEventsAdminByID {...props} auth={auth} />),
            //     role: [
            //         { "ID": 30, "nazvanie": "АдминистраторМероприятия" },
            //     ]
            // },
            {
                uuid: ":id/avatar",
                hidden: true,
                component: (props) => (<CommonEventsByIDAvatar {...props} auth={auth} />),
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                ]
            },
            {
                uuid: ":id/avatartemplate",
                hidden: true,
                component: (props) => (<CommonEventsByIDAvatarTemplate {...props} auth={auth} />),
                role: [
                    // { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                    { "ID": 15, "nazvanie": "АдминистраторОтделения" },
                    { "ID": 29, "nazvanie": "АдминистраторМероприятийРО" },
                    { "ID": 23, "nazvanie": "ОрганизаторФедерации" },
                    { "ID": 25, "nazvanie": "АдминистраторОрганизатораФедерации" },
                    { "ID": 18, "nazvanie": "ВладелецШколыФедерации" },
                    { "ID": 19, "nazvanie": "АдминистраторШколыФедерации" },
                    { "ID": 30, "nazvanie": "АдминистраторМероприятия" },
                ]
            },
        ]
        return x
    };

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    return (
        <MenuLevelThreeContext.Provider value={menu(status, notify)}>
        {(!siteAccess || siteAccess == "allow") && <Routes>
            {defaultRoute(menu(status, notify), role_by_id)}
            {menu(status, notify).map((e, idx) => {
                if (e.component && access(e, role_by_id)) {

                    return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                        <BreadcrumbsProvider value={{
                            // parent: props?.level,
                            uuid: e?.uuid,
                            name: e?.name,
                            color: e?.color,
                            role: e?.role,
                            hidden: e.hidden
                        }}>
                            {e.component({})}
                        </BreadcrumbsProvider>} />

                }
            })}
        </Routes>}
    </MenuLevelThreeContext.Provider>
    );
}
